import type { FormEditorStore } from "@/features/form-editor/state/form-editor-store";

/** Recursively sorts object keys so JSON serialization is stable for comparisons. */
function sortKeysDeep(value: unknown): unknown {
	if (value === null || typeof value !== "object") {
		return value;
	}
	if (Array.isArray(value)) {
		return value.map(sortKeysDeep);
	}
	const obj = value as Record<string, unknown>;
	const sorted: Record<string, unknown> = {};
	for (const key of Object.keys(obj).sort()) {
		sorted[key] = sortKeysDeep(obj[key]);
	}
	return sorted;
}

/**
 * Canonical string for comparing whether the builder canvas differs from a saved baseline.
 * Includes `formRules` so a rule edit/toggle/delete enables Cancel/Save like a canvas change.
 */
export function stringifyFormEditorCanvasForCompare(
	state: Pick<
		FormEditorStore,
		"formTitle" | "formDescription" | "rootIds" | "nodes" | "formRules"
	>,
): string {
	return JSON.stringify({
		formTitle: state.formTitle,
		formDescription: state.formDescription,
		rootIds: state.rootIds,
		nodes: sortKeysDeep(state.nodes),
		formRules: sortKeysDeep(state.formRules),
	});
}
